import { Box, Text } from '@stitch-fix/mode-react';
import styles from './styles.module.scss';

export const Heading = ({ title }: { title: string }) => (
  <Box className={styles.headingContainer}>
    <Text
      setting="display-medium"
      color="blue-45"
      as="h1"
      dangerouslySetInnerHTML={{ __html: title }}
    />
  </Box>
);
